/**
 * Created by Elive on 2017/8/9.
 */

export const LOGIN = 'login';

export const LOGOUT = 'logout';